import { translate } from 'i18n/i18n'

export const vicHeatmapColorAxisFormatter = (step: { isFirst: boolean; isLast: boolean }) => {
  if (step.isFirst) {
    return translate.phrases.banyanApp('Low')
  } else if (step.isLast) {
    return translate.phrases.banyanApp('High')
  }
}
